import { chatStore, ThreadBackgroundState } from '@/features/chat/chat.store';

export type TabChatStatus = 'unread' | 'in-progress' | 'idle';

export const getTabChatStatus = (
  threadId: string | undefined
): TabChatStatus => {
  if (!threadId) return 'idle';

  const backgroundState = chatStore.getThreadBackgroundStatus(threadId);
  switch (backgroundState) {
    case ThreadBackgroundState.BackgroundWithActivityNotified:
      return 'unread';
    case ThreadBackgroundState.BackgroundWithActivity:
      return 'in-progress';
    case ThreadBackgroundState.Background:
    case undefined:
      return 'idle';
    default: {
      const unhandledState: never = backgroundState;
      return unhandledState;
    }
  }
};
